/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SubscriptionPlan from './subscription-plan';
import SubscriptionPlanDetail from './subscription-plan-detail';
import SubscriptionPlanUpdate from './subscription-plan-update';
import SubscriptionPlanDeleteDialog from './subscription-plan-delete-dialog';

const SubscriptionPlanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SubscriptionPlan />} />
    <Route path="new" element={<SubscriptionPlanUpdate />} />
    <Route path=":id">
      <Route index element={<SubscriptionPlanDetail />} />
      <Route path="edit" element={<SubscriptionPlanUpdate />} />
      <Route path="delete" element={<SubscriptionPlanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SubscriptionPlanRoutes;
